import { PatientProps } from '../contexts/PatientContext';
import { makePatientRuleByPatientProps } from '../models/Patient';
import { PaymentValidation, PaymentValidationRule, PAYMENT_TYPES } from '../models/PaymentRule';
import { ProductItemOriginal } from '../models/Product';
import { Payment, Resource, ScheduleItemProps } from '../models/Schedule';
import { AdditionalInformations, fetchRuleValidation } from '../modules/validateRules';
import { InternalStatusCode } from '../utils/enums/validate-rules.enum';

type validateProductRulesProps = {
  patient: PatientProps;
  product: ProductItemOriginal;
  schedule: ScheduleItemProps;
};

export type ValidateProductData = {
  resource: Resource | null;
  modals: AdditionalInformations[];
} & Pick<validateProductRulesProps, 'product' | 'schedule'>;

type ValidateProductRulesResult = {
  error: boolean;
  errorMessage?: string;
  data: ValidateProductData;
};

export function useValidateProductRules() {
  function handleaymentType(payment: Payment) {
    if (payment.type === PAYMENT_TYPES.B2B && payment.eligibility?.codPlan)
      return PaymentValidation({
        type: PAYMENT_TYPES.B2B,
        additional_info: {
          plan_code: payment.eligibility?.codPlan
        }
      });
    if (payment.type === PAYMENT_TYPES.PARTICULAR)
      return PaymentValidation({
        type: PAYMENT_TYPES.PARTICULAR
      });
    return {} as PaymentValidationRule;
  }

  async function validateProductRules({
    patient,
    product,
    schedule
  }: validateProductRulesProps): Promise<ValidateProductRulesResult> {
    const result = {} as ValidateProductRulesResult;
    if (schedule.payment) {
      const patientRule = makePatientRuleByPatientProps(patient);
      const payment = handleaymentType(schedule.payment);
      const resultValidate = await fetchRuleValidation({
        patient: patientRule,
        product,
        payment
      });

      if (resultValidate.data.statusCode !== InternalStatusCode.OK) {
        result.errorMessage = resultValidate.message;
        result.error = true;
        return result;
      }

      const { product: productFromApi, resource, additional_information } = resultValidate.data.data;

      result.error = false;
      result.data = {
        schedule,
        product: productFromApi,
        resource,
        modals: additional_information
      };
    }
    return result;
  }

  return validateProductRules;
}
